<template>
  <div class="schedule" :class="{ 'p-3 p-md-5 with-bg': !bare }">
    <h2 class="mb-5" v-if="!bare">{{ $t('Harmonogram výstavby') }}</h2>
    <slot name="before" />
    <div class="d-flex flex-wrap">
      <div class="col-md p-0 phase" :class="{ fill: !!phase.status }" v-for="(phase, i) in phases" :key="i">
        <div class="icon">
          <img :src="require(`@/assets/icons/${phase.icon}.svg`)">
        </div>
        <h3 v-if="phase.roundLabel || phase.round !== undefined">
          <template v-if="phase.roundLabel">{{ $t(phase.roundLabel) }}</template>
          <template v-else-if="phase.round">{{ phase.round }}. {{ $t('fáza') }}</template>
          <template v-else>&nbsp;</template>
        </h3>
        <h3 v-html="$t(phase.title)"></h3>
        <div class="line" :class="[phase.status, { transparent: !phase.date }]"></div>
        <p class="date" v-if="phase.date">{{ $t(phase.date) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScheduleTimeline",
  props: {
    // phases: [{ icon, title, date, status, round }]
    // status: 'fill' (completed) | 'fill-min' (in progress) | undefined (upcoming)
    // round: optional round number shown as "N. fáza" above the title (0 renders a blank spacer);
    //        omit entirely for single-round schedules
    // date omitted -> no date shown, line gets the "transparent" modifier
    phases: {
      type: Array,
      required: true
    },
    // true when embedding inside a page section that already renders its own heading (e.g. a tab)
    bare: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px

.schedule
  &.with-bg
    background: var(--textBright)
  .phase
    @media (max-width: $md)
      border-left: 2px solid var(--textDark)
      padding-left: 15px !important
      display: flex
      flex-direction: column
      padding-bottom: 20px !important
      &.fill
        border-color: var(--blue)
        &:before
          background: var(--blue)
      &.fill-half
        &:before
          background: var(--blue)
        &:after
          content: ""
          width: 2px
          height: 60%
          background: var(--blue)
          position: absolute
          left: -2px
          top: 0
      &:last-child
        border-color: transparent
      &:before
        content: ""
        width: 12px
        height: 12px
        background: var(--textDark)
        border-radius: 50%
        position: absolute
        left: -7px
        top: 0
        margin-top: 0
  h3
    font-size: 16px
    font-weight: 500
    line-height: 20px
    letter-spacing: -0.5px
    @media (max-width: $md)
      order: 3
  p.date
    font-size: 16px
    line-height: 20px
    letter-spacing: -0.5px
    color: var(--blue)
    font-weight: 500
    @media (max-width: $md)
      order: 1
      margin-top: -3px
  .icon
    height: 40px
    margin-bottom: 10px
    @media (max-width: $md)
      order: 2
  .line
    margin: 20px 0
    height: 2px
    background: var(--textDark)
    position: relative
    @media (max-width: $md)
      display: none
    &:before
      content: ""
      width: 12px
      height: 12px
      background: var(--textDark)
      border-radius: 50%
      position: absolute
      left: 0
      top: 0
      margin-top: -5px
    &.fill
      background: var(--blue)
      &:before
        background: var(--blue)
    &.fill-half, &.fill-min
      &:before
        background: var(--blue)
    &.fill-min
      &:after
        width: 15%
    &.transparent
      background: transparent
</style>
